import { render, staticRenderFns } from "./SampleModalConfirmation.vue?vue&type=template&id=335edbde&scoped=true"
import script from "./SampleModalConfirmation.vue?vue&type=script&lang=js"
export * from "./SampleModalConfirmation.vue?vue&type=script&lang=js"
import style0 from "./SampleModalConfirmation.vue?vue&type=style&index=0&id=335edbde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335edbde",
  null
  
)

export default component.exports